import { render } from "./OrganisationPage.vue?vue&type=template&id=8856360a&scoped=true"
import script from "./OrganisationPage.vue?vue&type=script&lang=js"
export * from "./OrganisationPage.vue?vue&type=script&lang=js"

import "./OrganisationPage.vue?vue&type=style&index=0&id=8856360a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8856360a"]])

export default __exports__